module.exports = __webpack_public_path__ + "static/media/announcement.7f8498c1.svg";